<template>
  <div id="cronjob-page">
    <!-- page header -->
    <div class="bg-white shade py-2 px-3 mb-4" style="margin-top: 15px">
      <h3 style="font-size: 20px">
        <i class="bi bi-clock-history"></i>
        Daftar Cronjob Sistem
      </h3>
    </div>
    <!-- cronjob table component -->
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="p-3 bg-white shade">
          <table-dynamic-component
            :key="table_key"
            :data_head="data_head"
            :data_body="data_body"
            :config="data_config"
            :table_class="table_class"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import table_dynamic from "@/views/components/table_dynamic.vue";

export default {
  name: "Cronjob",
  components: {
    "table-dynamic-component": table_dynamic,
  },
  data() {
    return {
      table_key: 0,
      data_head: [
        "Nama File",
        "Jadwal Selanjutnya (GMT +7)",
        "Freq. per Jam",
        "Freq. per Hari",
        "Keterangan",
      ],
      data_body: [],
      data_config: { aaSorting: [[1, "asc"]] },
      table_class: "table-bordered",
    };
  },
  methods: {
    getData: function () {
      let api = process.env.VUE_APP_API_URL + "system/cron";
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.populateTable(response.data.jobs);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    populateTable: function (dataset) {
      let data = [];
      dataset.forEach((element) => {
        data.push([
          element.filename,
          element.next,
          element.per_hour,
          element.per_day,
          element.comment,
        ]);
      });
      this.data_body = data;
      this.table_key++;
    },
  },
  created: function () {
    this.getData();
  },
};
</script>